module.exports = __webpack_public_path__ + "img/desktop/Menus-betmenu/btn-paytable-up@3x.png?1.0.17";